import React, {Dispatch} from "react"
import TextField from "../Address/Textfield"
import {FullName} from "../../resources/common"

export interface FullNameInputProps {
	fullName: FullName
	handleChange: Dispatch<any>
	handleBlur: Dispatch<any>
}

export default function FullNameInput({fullName, handleChange, handleBlur}: FullNameInputProps) {
	return (
		<>
			<TextField
				label="First Name"
				placeholder="Enter first name"
				name="fullName.first"
				value={fullName.first}
				onChange={handleChange}
				onBlur={handleBlur}
			/>

			<TextField
				label="Last Name"
				placeholder="Enter last name"
				name="fullName.last"
				value={fullName.last}
				onChange={handleChange}
				onBlur={handleBlur}
			/>
		</>
	)
}
